import { defineAbilityFor } from "@adva/auth";
import { useMemo, type ReactNode } from "react";

import { AbilityContext } from "@/lib/ability-context";
import { useCurrentUser } from "@/hooks/use-current-user";

// ADV-879: derives the user's CASL ability from the current session and
// publishes it via AbilityContext. Re-derives on every login/business switch
// because useCurrentUser keys off the JWT.
export function AbilityProvider({ children }: { children: ReactNode }) {
  const currentUser = useCurrentUser();

  const ability = useMemo(
    () =>
      defineAbilityFor({
        systemRole: currentUser?.systemRole ?? "user",
        endUserRole: currentUser?.endUserRole ?? null,
        accountId: currentUser?.accountId ?? "",
        businessId: currentUser?.businessId ?? null,
        userId: currentUser?.userId ?? null,
      }),
    [currentUser],
  );

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}
